import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { listOrderLineItemsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';
import {
  MultiTransferFacilityButton,
  TransferFacilityProvider,
} from './MultiTransferFacilityButton';
import OrderLineItemsFilterButton from './OrderLineItemsFilterButton';
import OrderLineItemsFilterStatusBar from './OrderLineItemsFilterStatusBar';
import OrderLineItemsOuterFilter from './OrderLineItemsOuterFilter';
import OrderLineItemsTable from './OrderLineItemsTable';

const OrderLineItems = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.orderLineItems, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.ORDER_LINE_ITEMS)) {
      dispatch(listOrderLineItemsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.ORDER_LINE_ITEMS) return null;

  const reloadPage = () => {
    dispatch(listOrderLineItemsByPage({ page: currentPage }));
  };

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <OrderLineItemsFilterStatusBar />
      </Grid>
      <Grid item>
        <Grid container gap={2} alignItems='center'>
          <Grid item>
            <MultiTransferFacilityButton onSuccess={reloadPage} />
          </Grid>
          <Grid item>
            <OrderLineItemsOuterFilter />
          </Grid>
          <Grid item>
            <OrderLineItemsFilterButton />
          </Grid>
        </Grid>
      </Grid>
      <OrderLineItemsTable />
    </Grid>
  );
};

const OrderLineItemsWithProvider = () => {
  const preset = useSelector(({ workQueue }) => workQueue.preset);

  if (preset !== WorkQueues.ORDER_LINE_ITEMS) return null;

  return (
    <TransferFacilityProvider>
      <OrderLineItems />
    </TransferFacilityProvider>
  );
};

export default OrderLineItemsWithProvider;
